import React from "react";
import { motion } from "framer-motion";
import { Shirt, Share2 } from "lucide-react";

const REGISTRATION_URL = "https://in.njuko.com/pasteur-century-run1772850040777?currentPage=select-competition";

export default function Header() {
  return (
    <motion.header
      data-testid="header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="sticky top-0 z-40 bg-[#D8D8D8] border-b border-[#C4A15E]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        {/* Left spacer */}
        <div className="w-10 h-10" />

        {/* Center logo */}
        <div className="flex items-center justify-center">
          <img
            data-testid="header-logo"
            src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/ed4hlvm2_icono%20pasteur.png"
            alt="Pasteur Century Run 100"
            className="h-10 sm:h-12 w-auto object-contain"
          />
        </div>

        {/* Right spacer */}
        <div className="w-10 h-10" />
      </div>
    </motion.header>
  );
}
